"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const victory_1 = require("victory");
const { colors } = require("@atlaskit/theme");
class BarChart extends React.Component {
    render() {
        const { data, barWidth, color } = this.props;
        return (React.createElement(victory_1.VictoryBar, Object.assign({}, this.props, { style: { data: { fill: color } }, data: data, alignment: "middle", barWidth: barWidth })));
    }
}
exports.BarChart = BarChart;
BarChart.defaultProps = {
    width: 500,
    height: 500,
    color: colors.B200
};
BarChart.role = "bar";
